module.exports = __webpack_public_path__ + "static/media/caret-down-solid-full.6be873cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caret-down-solid-full.svg
// module id = 226
// module chunks = 0